import { type AppDispatch } from "features/Application/globaltypes/redux";
import DataService from "features/Application/services/dataServices/typedDataService";
import { errTags, gotTags } from "../slices/campaignTagsSlice";

export const fetchCampaignTags = () => async (dispatch: AppDispatch) => {
  try {
    const res = await DataService.threatDefence.campaigns.getTagsFilterOptionsAsync(true);

    dispatch(gotTags(res.data));
  } catch (e) {
    dispatch(errTags(e as Error));
  }
};
